export default __webpack_public_path__ + "static/media/marketplace-info-hero-3.cf952c5a.jpg";